import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './verification-upload-scan-form.magic.css.js';
import script from './verification-upload-scan-form.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('magic-ui-text',{staticClass:"text label",attrs:{"tag":"p","part":"text","content":_vm.documentType === 'photoID' ? _vm.$t('file-upload.label') : _vm.$t('file-upload.address.label')}}),_vm._v(" "),_c('magic-ui-button',{staticClass:"button button--scan",attrs:{"wide":"","no-margin":"","variant":"primary","button-tag":"label","part":"button","data-v-test-id":"file-upload-button","loading":_vm.isScanButtonLoading,"disabled":_vm.isScanButtonDisabled},domProps:{"innerHTML":_vm._s(_vm.documentType === 'photoID' ? _vm.$t('file-upload.scan.button') : _vm.$t('file-upload.address.scan.button'))},on:{"click":_vm.handleScanButtonClick}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text divider-text",attrs:{"tag":"p","part":"text","content":!_vm.disableManualUpload && _vm.allowAllDocumentsUpload
            ? (_vm.documentType === 'photoID' 
                ? _vm.$t('file-upload.scan.divider.text') 
                : _vm.$t('file-upload.address.scan.divider.text')) 
            : ''}}),_vm._v(" "),(!_vm.disableManualUpload && _vm.allowAllDocumentsUpload)?_c('magic-ui-text',{staticClass:"text",attrs:{"part":"text","data-v-test-id":"text","content":_vm.$t('corex.verification-notification')}}):_vm._e(),_vm._v(" "),(_vm.formConfig.length && (!_vm.disableManualUpload && _vm.allowAllDocumentsUpload))?_c('magic-form-builder',{key:_vm.formKey,attrs:{"data-v-test-id":"upload-form-container","state-key":("kyc-upload-" + _vm.documentType)},domProps:{"config":_vm.formConfig},on:{"form-change":_vm.onChange}}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-63ac11f7_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-63ac11f7";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
